module.exports = __webpack_public_path__ + "roc360.3c80515.png";